/**
 * HighlightText.jsx
 * 
 * Highlights search terms within any text.
 * Used in resume preview panel when boolean/plain search is active.
 * 
 * Usage:
 *   <HighlightText text="Expert in Java and Spring Boot development" terms={["java", "spring boot"]} />
 */

/**
 * Split text into segments: highlighted and plain
 */
function splitWithHighlights(text, terms) {
  if (!text || !terms || terms.length === 0) {
    return [{ text, highlight: false }];
  }

  // Build a single regex from all terms (case-insensitive)
  const escaped = terms
    .filter(Boolean)
    .map(t => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")); // escape special chars

  if (escaped.length === 0) return [{ text, highlight: false }];

  const regex = new RegExp(`(${escaped.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.map(part => ({
    text: part,
    highlight: escaped.some(e => new RegExp(`^${e}$`, "i").test(part)),
  }));
}

/**
 * Inline highlight component
 */
const HighlightText = ({ text, terms = [], className = "" }) => {
  if (!text) return null;

  const segments = splitWithHighlights(String(text), terms);

  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.highlight ? (
          <mark
            key={i}
            className="bg-yellow-200 text-yellow-900 rounded px-0.5 font-semibold not-italic"
            style={{ backgroundColor: "#fef08a", color: "#713f12" }}
          >
            {seg.text}
          </mark>
        ) : (
          <span key={i}>{seg.text}</span>
        )
      )}
    </span>
  );
};

export default HighlightText;